import { render, staticRenderFns } from "./process-approve.vue?vue&type=template&id=1b410362"
import script from "./process-approve.vue?vue&type=script&lang=ts"
export * from "./process-approve.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports